import React, { useState } from "react";

import { GenerationSubscription } from "./GenerationSubscription";

import ApiData from "../../api/ApiData";

import { observer } from "mobx-react-lite";

import { CcV4Toggle } from "../UI/CcV4Toggle";

import RolesState from "../../api/RolesState";

import Msg from "../../api/Msg";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import { formatIsoDateShortDisplay } from "../../utils/subscriptionPeriodDate";

export const SubscriptionComponentCard = observer(() => {
  const [newFlag, setNewFlag] = useState(false);

  const [prolongation, setProlongation] = useState(false);

  const openNew = () => {
    setNewFlag(true);
    setProlongation(false);
  };

  const openProlongation = () => {
    setNewFlag(false);
    setProlongation(true);
  };

  const subscriptionRel = ApiData.company.company?.subscription_rel;

  const checkValidSubscription = () => {
    if (!subscriptionRel?.length) return false;

    const dateSubscription = new Date(
      subscriptionRel[0].validity_date,
    ).getTime();
    const todayDate = new Date().getTime();

    return dateSubscription > todayDate;
  };

  const postFunc = async (obj) => {
    if (subscriptionRel?.[0] && !checkValidSubscription()) {
      await ApiData.prolongationSubscription(obj.valid_period);
    } else {
      await ApiData.postSubscription(obj);
    }
  };

  const validityDate = subscriptionRel?.[0]?.validity_date;
  const isActive = checkValidSubscription();

  if (subscriptionRel) {
    return (
      <div className="subscription-v4-block">
        <div
          className={
            isActive
              ? "sub-status-box sub-active"
              : "sub-status-box sub-inactive"
          }
        >
          <span className="sub-status-main">
            {isActive ? "Подписка активна" : "Подписка не активна"}
          </span>
          {RolesState.patch_subscription ? (
            <CcV4Toggle
              active={isActive}
              onClick={isActive ? () => ApiData.deleteSubscription() : openNew}
            />
          ) : null}
          {isActive && validityDate ? (
            <span className="sub-status-date">
              до {formatIsoDateShortDisplay(validityDate)}
            </span>
          ) : null}
          <div className="flx-sb">
            {isActive && RolesState.patch_subscription ? (
              <BtnPrimaryv4
                text="Продлить подписку"
                onClick={openProlongation}
              />
            ) : null}

            {isActive && validityDate ? (
              <BtnOutlineV4
                className="sub-status-comment-btn"
                text="информация"
                onClick={() =>
                  Msg.writeMessages(subscriptionRel?.[0]?.descriptions)
                }
              />
            ) : null}
          </div>
        </div>
        {newFlag ? (
          <GenerationSubscription
            newFlag={newFlag}
            flag={setNewFlag}
            title="Активация лицензии"
            func={postFunc}
          />
        ) : null}
        {prolongation ? (
          <GenerationSubscription
            func={ApiData.prolongationSubscription}
            title="Продление лицензии"
            flag={setProlongation}
            prolongationBaseDate={validityDate}
          />
        ) : null}
      </div>
    );
  }

  return null;
});
